import React, { useEffect, useState } from 'react'
import { getStarClassName } from './utils/filter';
import { useSelector } from 'react-redux';

const StarFilter = ({ packageResult, filters, handleFilterChange }) => {
    const lang = useSelector((state) => state.culture.language);

    const [starRatingCounts, setStarRatingCounts] = useState([]);

    const handleCheckboxChange = (rating) => {
        const updatedRatings = filters.starRatings.includes(rating)
            ? filters.starRatings.filter((r) => r !== rating)
            : [...filters.starRatings, rating];
        handleFilterChange("starRatings", updatedRatings);
    };

    useEffect(() => {
        if (packageResult && packageResult.length > 0) {

            const counts = packageResult.reduce((acc, item) => {
                const rating = item.Features?.StarRating || 0; // Default to 0 if no rating
                acc[rating] = (acc[rating] || 0) + 1;// Increment count for the rating
                return acc;
            }, {});

            const starData = [5, 4, 3, 2, 1].map((rating) => ({
                rating,
                count: counts[rating] || 0, // If no packages, set count to 0
            }));
            setStarRatingCounts(starData);

        }
    }, [packageResult]);

    const handleClear = () => {
        handleFilterChange("starRatings", [])
        // setRange(priceRange)
    }

    return (
        <div className="Filterbox">
            <div className="Filterhead d-flex justify-content-between">
                <div className="FilterTitle d-flex">
                    {" "}
                    {lang.star_rating}
                </div>
                <div>
                    {" "}
                    <span className="filter_clear">
                        <a href={undefined} onClick={handleClear}>{lang.clear}</a>
                    </span>{" "}
                </div>
            </div>
            <div className="FilterContent hotlfilterstar">
                <ul className="filterCheck">
                    {starRatingCounts.map((item) => (
                        <li key={item.rating}>
                            <input
                                type="checkbox"
                                id={`star_${getStarClassName(item.rating)}`}
                                name="starflow"
                                checked={filters.starRatings.includes(
                                    item.rating
                                )}
                                onChange={() =>
                                    handleCheckboxChange(item.rating)
                                }
                            />
                            <label
                                htmlFor={`star_${getStarClassName(
                                    item.rating
                                )}`}
                                className="star_segement"
                            >
                                {" "}
                                <span>({item.count})</span>{" "}
                                <span
                                    className={`star_filter ${getStarClassName(
                                        item.rating
                                    )}`}
                                />{" "}
                            </label>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default StarFilter